import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import MainLayout from "@/components/feature/MainLayout";
import Home from "@/pages/home/page";
import Movies from "@/pages/movies/page";
import MovieDetail from "@/pages/movies/detail/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "movies",
        element: <Movies />,
      },
      {
        path: "movies/detail/:id",
        element: <MovieDetail />,
      },
      {
        path: "news",
        element: <News />,
      },
      {
        path: "news/detail/:id",
        element: <NewsDetail />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;